import React from "react"

import { useNavigate, useParams, useLocation } from "react-router-dom";

import { Typography, Divider } from "@mui/material"

import * as F from 'tsui/Form'

interface Props {
    email: string;
}


export default function JoinConfirmUserEmailPage(props: Props) {
    const form = F.useForm({
        type: 'input',
    })

    const search = useLocation().search;
    const urlParams = new URLSearchParams(search);
    const email = urlParams.get('email');
    const [status, setStatus] = React.useState('');
    const [disabled, setDisabled] = React.useState(false);

    const onSubmit = React.useCallback((evt: F.InputFormEvent) => {
        // console.debug("on submit");

        // confirmCodeRef.current = confirmCode!
        console.log('evt.data', evt.data)
        console.log('evt.data.confirmUserEmail', evt.data.confirmUserEmail)
        if (form.error)
            return;


      

        // AuthApi.confirmUserEmail({ email: props.email, code: evt.data.confirmUserEmail }).then((sess) => {
        //     // form.clearBusy();
        //     // // navigate('/');   
        //     // setStatus('Your verification code has been sent')
        //     // setDisabled(true);
        //     // props.onClose()
        // }).catch(err => form.setError(err));


    }, []);



    // return <PageContents title='Join verification'>
    return <F.PageForm title='JOIN CONFIRM' form={form} size='lg' onSubmit={onSubmit} >
        {/* <Form.PageInputForm title='Thanks for joining' onSubmit={onSubmit} form={form} size='md' > */}
            <Divider sx={{ width: '100%', p: 1 }} />
            <Typography sx={{ fontSize: '1.2rem', p: 2 }} >Verification email has been sent, please check your inbox!</Typography>

            {/* <Form.InputText form={form} xs={8} id='confirmUserEmail' label='Confirm User Email' placeholder='Confirm User Email' required data={false} /> */}
            <F.InputText form={form} xs={8} id='confirmUserEmail' label='Confirm User Email' placeholder='Confirm User Email' autocomplete='given-name' required />

            <Typography sx={{ width: '100%', textAlign: 'center', fontSize: '0.8rem', color: '#616161' }}>Haven't got one? click the button below</Typography>
            {/* <Form.SubmitButton  disabled={disabled} align="center" label='resend' form={form} xsMax/> */}
            <F.SubmitButton disabled={disabled} align="center" label='SEND' form={form} xsMax />
            <Typography sx={{ width: '100%', textAlign: 'center', fontSize: '0.8rem', color: 'green' }}>{status}</Typography>
        {/* </Form.PageInputForm> */}

    </F.PageForm>

}

